import { SIGN_IN_MENU_ITEMS } from "~/models/signin";
import { DesktopMenuItem } from "./DesktopMenuItem";

export function DesktopMenu(props: {
  color?: string;
  backgroundColor?: string;
}) {
  return (
    <div
      className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-4 tw:py-8 tw:px-6 tw:rounded-lg tw:w-full"
      style={{ backgroundColor: props.backgroundColor ?? undefined }}
    >
      {SIGN_IN_MENU_ITEMS.map((item) => (
        <DesktopMenuItem
          key={item.label}
          label={item.label}
          link={item.link}
          color={props.color}
        />
      ))}
    </div>
  );
}
